// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2IZ48","name":"ConsentHeader_name__2Vhtg","birthday":"ConsentHeader_birthday__3dxdR","skeleton":"ConsentHeader_skeleton__1vVYD"};